/* ========================================================================
 *  FD
 * ========================================================================
*/
var FD = (function (w) {
    return {};
}(window));


/* ========================================================================
 *  initialize the page
 * ========================================================================
*/
FD.Page = (function ($, me) {
    'use strict';

    var child = me.Page || {};


    //  after control event 
    child.getAfterControlEvent = function (data) { };


    //  get view props
    child.getViewProps = function () { };


    //  init
    child.init = function () { };

    return child;
}(jQuery, FD));
